module.exports = {"410411001":"马庄街道","410411002":"南环路街道","410411003":"姚孟街道","410411004":"九里山街道","410411005":"轻工路街道","410411006":"高阳路街道","410411007":"北渡街道","410411008":"荆山街道","410411009":"河滨街道","410411200":"曹镇乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410411.json
// module id = 1678
// module chunks = 0